var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66636 19.8364H13.333C16.683 19.8364 17.283 18.4078 17.458 16.6686L18.083 9.56986C18.308 7.40473 17.7247 5.63892 14.1664 5.63892H5.83303C2.27469 5.63892 1.69136 7.40473 1.91636 9.56986L2.54136 16.6686C2.71636 18.4078 3.31636 19.8364 6.66636 19.8364Z",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 5.63886V4.92898C6.66699 3.35838 6.66699 2.08948 9.33366 2.08948H10.667C13.3337 2.08948 13.3337 3.35838 13.3337 4.92898V5.63886",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6663 11.8504V12.7377C11.6663 12.7466 11.6663 12.7466 11.6663 12.7555C11.6663 13.7227 11.658 14.5124 9.99967 14.5124C8.34967 14.5124 8.33301 13.7315 8.33301 12.7643V11.8504C8.33301 10.963 8.33301 10.963 9.16634 10.963H10.833C11.6663 10.963 11.6663 10.963 11.6663 11.8504Z",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.042 10.0756C16.117 11.5663 13.917 12.4536 11.667 12.7553",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18359 10.3153C4.05859 11.6818 6.17526 12.5071 8.33359 12.7644",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.be972e4deba63bfbe5469a5b80fa2ced.svg";
export { ForwardRef as ReactComponent };